import * as React from 'react';
import { styled } from './druid/./druid/./druid/Utilities';
import { ColorSliderBase } from '/druid/ColorSlider.base';
import { getStyles } from '/druid/ColorSlider.styles';
import { IColorSliderProps, IColorSliderStyleProps, IColorSliderStyles } from '/druid/ColorSlider.types';

export const ColorSlider: React.FunctionComponent<IColorSliderProps> = styled<
  IColorSliderProps,
  IColorSliderStyleProps,
  IColorSliderStyles
>(ColorSliderBase, getStyles, undefined, { scope: 'ColorSlider' });
